module.exports = __webpack_public_path__ + "static/image/history/pc/201103.jpg?922d2eb1";